import { apiClient } from '@indipia/shared/api/client';
import { API_PRX } from '@indipia/shared/api/endpoints';
import type { ApiResponse } from '../types/worklog.types';
import type { CustReqApplyResult } from '../types/custReqReport.types';

// 작업보고 화면의 고객 요청(S16) 호출 — sv-worklog (K1 3.2). 요청 원장 호출은 shared-features custReqApi 를 쓴다.
//  POST /worklog/field-reports/{fieldReportId}/customer-requests/{custReqId}/apply : 사장 [반영 처리]

export const custReqReportApi = {
  /** 사장 [반영 처리] — 반영됨으로 전환. 이미 완료된 보고면 같은 호출에서 확인까지 전환된다. */
  async applyByOwner(fieldReportId: number, custReqId: number, signal?: AbortSignal): Promise<CustReqApplyResult> {
    const res = await apiClient.post<ApiResponse<CustReqApplyResult>>(
      `${API_PRX.WORKLOG}/field-reports/${fieldReportId}/customer-requests/${custReqId}/apply`,
      undefined,
      { signal },
    );
    const d = res.data?.data;
    // 필수 응답이 없으면 기본값으로 채우지 않고 오류
    if (!d?.item) throw new Error('반영 처리 응답이 비어 있음');
    return d;
  },
};
